import { ReactElement } from "react";
import { Empty2 } from "@ps/ui-components";
import { useTranslationWithNamespace } from "../../../../hooks";
import { ReactComponent as AccIcon } from "../../../../images/profile-summary/acc.svg";
import OtherSummaryHeader from "./otherSummaryHeader";
import { ExpProps } from "../types";

const Accomplishment = ({
  filled,
  children,
  onAddOrEditClick,
}: ExpProps): ReactElement => {
  const { t } = useTranslationWithNamespace();
  return (
    <div className="flex flex-col gap-y-8">
      <OtherSummaryHeader
        title={t("profile.experience.sections.accomplishment")}
        Icon={<AccIcon className="text-neutralSecondary-41" />}
        withButton
        onButtonClick={onAddOrEditClick}
        filled={filled}
      />
      {filled ? (
        children
      ) : (
        <Empty2
          section={t("profile.experience.sections.accomplishment")}
          onClick={onAddOrEditClick}
        />
      )}
    </div>
  );
};

export default Accomplishment;
